import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";

export default function ReconnectBanner() {
  const [active, setActive] = useState(false);
  useEffect(() => {
    const h = (e) => setActive(!!(e.detail && e.detail.active));
    window.addEventListener("sgex:reconnecting", h);
    return () => window.removeEventListener("sgex:reconnecting", h);
  }, []);
  if (!active) return null;
  return (
    <div data-testid="reconnect-banner"
      className="fixed top-0 inset-x-0 z-[2000] flex items-center justify-center gap-2 h-9 bg-red-500 text-white text-sm font-medium shadow-md animate-fade-in">
      <Loader2 size={15} className="animate-spin" />
      Server is restarting - reconnecting…
    </div>
  );
}
